import KunLoading46 from './src/index'

KunLoading46.install = function (Vue) {
	Vue.component(KunLoading46.name, KunLoading46);
}

export default KunLoading46;
